module.exports = {
  // make sure all cards name are in lower case
  PAYMENT_WIDGET_CARD: 'paymentwidget',
  DATE_PICKER_CARD: 'datepicker',
  SINGLE_DATE_PICKER_CARD: 'singledatepicker',
  REFUND_TRACKER_CARD: 'refundtracker',
  REWARDS_TRACKER_CARD: 'rewardstracker',
  FLIGHTS_CHANGE: 'flightschange',
  FLIGHTS_CREDIT_BOOKING: 'flightscreditbooking',
  DATA_COLLECTOR: 'datacollection',
  AIR_FARE_RULES: 'airfarerules',
  FARE_RULES: 'farerules',
  PENALTY: 'penalty',
  TERMS_AND_CONDITIONS: 'termsandconditions',
  PNR_DETAILS: 'pnrdetails',
  UNKNOWN_CARD: 'unknown',
  FLIGHT_REFUND: 'flightrefund',
  FLIGHT_SCHEDULE_CHANGE: 'flightschedulechange',
  ERROR_VIEW: 'errorview',
  DECLARATIVE_CARD: 'declarativecard',
};
